<template>
  <div v-if="statusGroup">
    <label class="font-weight-light">
      {{ $t('redemption-history-delivery-status-label') }}
    </label>
    <v-icon
      :color="color"
      small
    >
      {{ icon }}
    </v-icon>
    <span class="status-label">
      {{ label }}
    </span>
    <p
      v-if="showDescription"
      class="my-2 status-description"
    >
      {{ description }}
    </p>
  </div>
</template>
<script>
import {
  IsDeliveredStatuses,
  IsFailedStatuses,
  IsPendingStatuses
} from '@/store/classes/delivery-status'

export default {
  name: 'DeliveryStatus',
  props: {
    status: {
      type: String,
      required: false,
      default: ''
    },
    showDescription: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pending () {
      return {
        label: this.$t('redemption-history-delivery-status-pending.label'),
        description: this.$t(
          'redemption-history-delivery-status-pending.description'
        ),
        color: 'blue darken-3',
        icon: 'mdi-send'
      }
    },
    delivered () {
      return {
        label: this.$t('redemption-history-delivery-status-delivered.label'),
        description: this.$t(
          'redemption-history-delivery-status-delivered.description'
        ),
        color: 'success',
        icon: 'mdi-check-circle'
      }
    },
    failed () {
      return {
        label: this.$t('redemption-history-delivery-status-failed.label'),
        description: this.$t(
          'redemption-history-delivery-status-failed.description'
        ),
        color: 'error',
        icon: 'mdi-close-circle'
      }
    },
    statusGroup () {
      if (IsPendingStatuses.includes(this.status)) {
        return this.pending
      } else if (IsDeliveredStatuses.includes(this.status)) {
        return this.delivered
      } else if (IsFailedStatuses.includes(this.status)) {
        return this.failed
      } else {
        return null
      }
    },
    label () {
      const { label } = this.statusGroup || {}
      return label
    },
    description () {
      const { description } = this.statusGroup || {}
      return description
    },
    color () {
      const { color } = this.statusGroup || {}
      return color
    },
    icon () {
      const { icon } = this.statusGroup || {}
      return icon
    }
  }
}
</script>
<style scoped lang="scss">
.status-label {
  font-weight: bold;
}
</style>
